import { type Chain } from "viem";
import { type NetworkType } from "../models/app-config";
import {
  IcArbitrumOne,
  IcBSC,
  IcEthereum,
  IcOptimisticEthereum,
  IcPolygonMatic,
} from "~/src/assets/icon";

export enum ChainId {
  ETHEREUM = 1,
  BSC_MAINNET = 56,
  BSC_TESTNET = 97,
  POLYGON = 137,
}

export const ETH = {
  name: "Ether",
  symbol: "ETH",
  decimals: 18,
};

export const POL = {
  name: "POL",
  symbol: "POL",
  decimals: 18,
};

export const BNB = {
  name: "BNB",
  symbol: "BNB",
  decimals: 18,
};

export const getBlockExplorerUrlByChain: any = (
  chainId: number,
  chains: readonly [Chain, ...Chain[]]
) => {
  const chain = chains.find((n) => Number(n?.id) === Number(chainId));
  return chain?.blockExplorers?.default.url ?? "";
};

export const getChainNameByChainId: any = (
  chainId: number,
  chains: readonly [Chain, ...Chain[]]
) => {
  const chain = chains.find((n) => Number(n.id) === Number(chainId));
  return chain?.name ?? "";
};

export const getSupportChainNameById: any = (
  chainId: number | string,
  supportNetworks: NetworkType[]
) => {
  if (!chainId) return "";
  const chain = supportNetworks?.find(
    (item) => item.chain_id === Number(chainId)
  );
  return chain?.name ?? "";
};

export const numberToHex = (num: number): string => {
  const val = Number(num);
  return "0x" + val.toString(16);
};

export const ChainImageURL: Record<number, string> = {
  1: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880", // Ethereum
  10: "https://assets.coingecko.com/coins/images/25244/standard/Optimism.png?1696524385", // "Optimistic"
  56: "https://assets.coingecko.com/asset_platforms/images/1/small/bnb_smart_chain.png?1706606721", // BSC
  97: "https://assets.coingecko.com/coins/images/825/large/binance-coin-logo.png?1547034615", // TBNB
  137: "https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912", // Polygon Pos
  1101: "https://assets.coingecko.com/asset_platforms/images/122/small/polygonzkevm.jpg?1706606698", // Polygon-zkevm,
  42161:
    "https://assets.coingecko.com/coins/images/16547/standard/arb.jpg?1721358242", // Arbitrum
};

export const ChainIconList: Record<string, string> = {
  ETHEREUM: IcEthereum, // Ethereum
  OPTIMISTIC: IcOptimisticEthereum, // "Optimistic"
  BSC: IcBSC, // BSC
  TBNB: IcBSC, // TBNB
  POLYGON: IcPolygonMatic, // Polygon Pos
  ARBITRUM: IcArbitrumOne, // Arbitrum
};
